/* eslint-disable import/prefer-default-export */
import React from 'react'
import { returnsClickEvent } from '@components/returns/helpers'
import Translations from '@helpers/translations'
import { objectOmit } from '@helpers/utils'
import { RETURN_REASON_CODES } from '@components/returns/consts'
import { Button } from '@components/ui/Button'
import { Values, ExchangesSizeOption } from '@components/returns/types'
import ButtonsWrapper from '../../../shared/ButtonsWrapper'
import DropdownSizeOptionsList from '../../../shared/DropdownSizeOptionsList'
import FormWrapper from '../../../shared/FormWrapper'
import styles from '../../../shared/styles.module.scss'
import { ProductSizes } from '@api/returns/types'

export type SizesStepProps = {
  values: Values & { sizes: Values['sizes'] & { available?: boolean } }
  sizes: Partial<ProductSizes>
  setSelection: (
    args: Partial<{
      color: Values['color']
      sizes: Values['sizes'] & { available?: boolean }
    }>
  ) => void
  exchangesSizeOptions: ExchangesSizeOption[]
  onUpdate: (step: string) => void
  isLastStep: boolean
}

export function SizesStep({
  values,
  sizes,
  exchangesSizeOptions,
  setSelection,
  onUpdate,
  isLastStep
}: SizesStepProps) {
  const isReasonColor = values.reason === RETURN_REASON_CODES.COLOR
  const hasChangedSizes =
    JSON.stringify(objectOmit(values.sizes, ['available'])) !==
    JSON.stringify(sizes)

  const titleText = isReasonColor
    ? 'Do you want to change size?'
    : 'Select your new size'

  const isSizesExchangeValid =
    values.sizes?.available &&
    exchangesSizeOptions.every(
      option => !!values.sizes[option.id as keyof typeof values.sizes]
    )

  const buttonText = (() => {
    if (!isLastStep) {
      return 'Next'
    }

    if (isReasonColor && !hasChangedSizes) {
      return 'Keep this size'
    }

    return Translations.localise('pages.returns.done')
  })()

  const handleUpdate = (step: string) => {
    returnsClickEvent({
      label: buttonText
    })
    if (step === 'prev') {
      setSelection({ sizes, color: undefined }) // reset to original product sizes
    }
    onUpdate(step)
  }
  return (
    <>
      <FormWrapper title={titleText}>
        <div className={styles.returnsForm__sizesContainer}>
          {exchangesSizeOptions.map(listItem => (
            <DropdownSizeOptionsList
              key={listItem.id}
              sizeOptions={listItem}
              setSelection={setSelection}
              sizes={sizes}
              values={values}
            />
          ))}
        </div>
      </FormWrapper>
      <ButtonsWrapper onUpdate={handleUpdate}>
        <Button
          disabled={!isSizesExchangeValid}
          classes={styles.returnsForm__button}
          variant="primary"
          fullWidth="always"
          onClick={() => handleUpdate(isLastStep ? 'done' : 'next')}
        >
          {buttonText}
        </Button>
      </ButtonsWrapper>
    </>
  )
}
